<template>
    <v-container fluid>
        <template v-if="!planPackage">
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />
                </v-col>
            </v-row>
        </template>

        <template v-else>
            <v-row v-if="planPackage.channel">
                <v-col>
                    <v-btn
                        color="indigo"
                        class="white--text"
                        :to="{
                            name: 'planPackageModules.create',
                            params: { id: planPackage.id },
                        }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        {{
                            $t('resources.default.add', {
                                resource: $tc(
                                    'resources.planPackageModule.name',
                                    1,
                                ),
                            })
                        }}
                    </v-btn>
                    <v-btn
                        color="purple"
                        class="white--text ml-2"
                        :to="{
                            name: 'planPackageModules.batchCreate',
                            params: { id: planPackage.id },
                        }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t('planPackageModules.actions.batch-create') }}
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="mb-5 pa-2">
                        <CardHeader :title="cardHeaderTitle" />
                        <template v-if="planPackage">
                            <v-row class="pl-6">
                                <v-col>
                                    <package-details
                                        :plan-package="planPackage"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <sarala-table :model="modules" ref="table">
                                        <template #module_name="{ item }">
                                            {{ item.module.name }}
                                        </template>
                                        <template #price_type="{ item }">
                                            {{
                                                $t(
                                                    'planPackageModules.index.table.values.price_type.' +
                                                        item.price_type,
                                                )
                                            }}
                                        </template>
                                        <template #amount="{ item }">
                                            {{
                                                item.add_on
                                                    ? $t(
                                                          'planPackageModules.index.table.headers.add_on',
                                                      )
                                                    : item.amount
                                            }}
                                        </template>
                                        <template #add_on="{ item }">
                                            {{
                                                item.add_on
                                                    ? $t(
                                                          'resources.default.yes',
                                                      )
                                                    : $t('resources.default.no')
                                            }}
                                        </template>
                                        <template
                                            #action
                                            v-if="planPackage.channel"
                                        >
                                        </template>
                                    </sarala-table>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import PlanPackage from '@/models/plans/PlanPackage'
import PlanPackageModule from '@/models/plans/PlanPackageModule'
import SaralaTable from '@/shared/components/SaralaTable'
import PackageDetails from '@/views/planPackages/PackageDetails'

export default {
    props: ['id'],

    data: () => ({
        planPackage: null,
        modules: null,
    }),

    components: {
        CardHeader,
        SaralaTable,
        PackageDetails,
    },

    methods: {
        async getPlanPackage() {
            const planPackage = new PlanPackage()
            this.planPackage = await planPackage.find(this.id)

            this.modules = new PlanPackageModule(this.planPackage.id)
        },
    },

    created() {
        this.getPlanPackage()
    },

    computed: {
        cardHeaderTitle() {
            return this.planPackage
                ? this.$t('planPackages.form.texts.title-modules', {
                      plan: this.planPackage.name,
                  })
                : this.$t('planPackages.form.texts.title-modules', {
                      plan: '',
                  })
        },
    },
}
</script>
